import { useEffect } from 'react';

// Playback speed for RECORDED video (1× / 2× / 4× / 8×). Recordings only — a
// live stream has nothing ahead of "now" to play faster.
export const PLAY_SPEEDS = [1, 2, 4, 8];
export const nextSpeed = s => PLAY_SPEEDS[(PLAY_SPEEDS.indexOf(s) + 1) % PLAY_SPEEDS.length];

// Keeps the <video> at `speed`. Loading new media resets playbackRate, so it is
// re-applied on loadedmetadata; mediaKey re-binds when the element is swapped.
export function useVideoSpeed(videoRef, speed, mediaKey) {
  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const apply = () => { v.defaultPlaybackRate = speed; v.playbackRate = speed; };
    apply();
    v.addEventListener('loadedmetadata', apply);
    return () => v.removeEventListener('loadedmetadata', apply);
  }, [videoRef, speed, mediaKey]);
}

// The speed lives with the caller, so it survives the player being remounted
// for the next recording segment.
export default function PlaybackSpeedButton({ videoRef, speed, onChange, mediaKey, className, style }) {
  useVideoSpeed(videoRef, speed, mediaKey);
  return (
    <button type="button" className={className} style={style} title="Playback speed"
      onClick={() => onChange(nextSpeed(speed))}>
      {speed}×
    </button>
  );
}
